module.exports = __webpack_public_path__ + "img/sample-histogram.5fa284ae.png";